<div class="container">
    <div *ngIf="showProgressBar">
        <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
      </div>
    <form [formGroup]="testDurationForm" (ngSubmit)="submit(testDurationForm)">
        <h1 mat-dialog-title class="text-center">Edit Test Duration</h1>
        <mat-dialog-content class="text-center">
            <mat-form-field>
                <input type="number" matInput formControlName="testDuration" placeholder="Test Duration" max="{{maxVal}}">
                <mat-error *ngIf="testDurationForm.get('testDuration').errors?.required">
                    Test Duration is <strong>required</strong>
                </mat-error>
            </mat-form-field>
            &nbsp; &nbsp;
        </mat-dialog-content>
        <div class="d-flex justify-content-center">
            <mat-dialog-actions>
                <button mat-button type="submit" [disabled]="testDurationForm.invalid">Set</button>
                <button mat-button type="button" (click)="dialogRef.close()">Close</button>
            </mat-dialog-actions>
        </div>
        <br>
        <!-- <div class="row"  *ngIf="showMsg">
            <div class="col-xs-12">
                <p class="alert alert-success"><strong>Test Duration updated to {{testDurationForm.value.testDuration}} minutes and will be reflected in Telemetry Page View after 1 hour.</strong></p>
            </div>
        </div> -->
        <mat-error *ngIf="notSuccess" class="d-flex justify-content-center">
            <strong>Unable to Edit Test Duration. Please try later !! </strong>
        </mat-error>
        <mat-error *ngIf="adminMaxValidate" class="d-flex justify-content-center">
            <strong>Test Duration value should be between 0 to 125</strong>
        </mat-error>
        <mat-error *ngIf="nonAdminMaxValidate" class="d-flex justify-content-center">
            <strong>Test Duration value should be between 0 to 12</strong>
        </mat-error>
    </form>
</div>

